/* eslint-disable import/no-cycle,no-param-reassign */
import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { API_URL } from '@/config';
import LocalStorageService from '@/services/localStorage.service';
import router from '@/router';
import store from '@/store';
import { PURGE_AUTH } from '@/store/modules/auth/authMutations.type';
import TurnstileService from '@/services/turnstile.service';

// Add a request interceptor
axios.interceptors.request.use(
  (cfg) => {
    if (LocalStorageService.getToken()) {
      const token = LocalStorageService.getToken();
      cfg.headers.Authorization = `Bearer ${token}`;
    }

    // Attach Turnstile token to auth endpoints only
    const url = cfg.url || '';
    const needsTurnstile = [
      '/auth/user/register',
      '/auth/user/login',
      '/auth/user/forgot-password',
      '/auth/user/reset-password',
      '/auth/user/resend-confirm-email',
    ].some(p => url.includes(p));

    if (needsTurnstile) {
      const ts = TurnstileService.getToken();

      // If request is JSON, merge into cfg.data
      if (cfg.data && typeof cfg.data === 'object') {
        cfg.data.cf_turnstile_response = ts;
      } else if (!cfg.data) {
        cfg.data = { cf_turnstile_response: ts };
      }

      // If it's form data, append
      if (cfg.data instanceof FormData) {
        cfg.data.append('cf_turnstile_response', ts);
      }
    }

    return cfg;
  },
  err => Promise.reject(err),
);

// Add a response interceptor
axios.interceptors.response.use(
  (res) => {
    // TODO do not remove this line and add metrics/tracking for api with slack client
    // eslint-disable-next-line no-console
    console.log('RESPONSE INTERCEPTOR SUCCESS');
    return res;
  },
  (err) => {
    const payload = err && err.response && err.response.data ? err.response.data : null;

    // Preserve existing side-effects, but guard err.response
    if (err && err.response && err.response.status === 401) {
      store.commit(PURGE_AUTH);
    }

    if (err && err.response && err.response.status === 403) {
      router.push({ name: 'home' });
    }

    if (err && err.response && err.response.status === 422) {
      return Promise.reject(err.response.data.errors);
    }

    // Reject an Error (eslint happy) but keep old shape (UI happy)
    if (payload && typeof payload === 'object') {
      const e = new Error(payload.message || 'Request failed');
      Object.assign(e, payload);
      e.httpStatus = err.response && err.response.status;
      return Promise.reject(e);
    }

    const e = new Error((err && err.message) ? err.message : 'Request failed');
    e.status = 'ERROR';
    e.httpStatus = err.response && err.response.status;
    return Promise.reject(e);
  },
);

export default {
  init() {
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = API_URL;
  },
  get(url) {
    return Vue.axios.get(url);
  },

  post(resource, params) {
    return Vue.axios.post(resource, params);
  },

  socialLogin(resource) {
    return Vue.axios.get(resource);
  },

  socialLoginSuccess(resource) {
    return Vue.axios.get(`${resource}?`);
  },
};
